__turbopack_context__.v({
  "articleLink": "sj3K7a_articleLink",
  "badge": "sj3K7a_badge",
  "body": "sj3K7a_body",
  "card": "sj3K7a_card",
  "control": "sj3K7a_control",
  "controls": "sj3K7a_controls",
  "dot": "sj3K7a_dot",
  "empty": "sj3K7a_empty",
  "image": "sj3K7a_image",
  "meta": "sj3K7a_meta",
  "number": "sj3K7a_number",
  "openArticle": "sj3K7a_openArticle",
  "pause": "sj3K7a_pause",
  "position": "sj3K7a_position",
  "ranking": "sj3K7a_ranking",
  "save": "sj3K7a_save",
  "selectors": "sj3K7a_selectors",
  "shade": "sj3K7a_shade",
  "spotlight": "sj3K7a_spotlight",
  "story": "sj3K7a_story",
  "storyBody": "sj3K7a_storyBody",
  "swiper": "sj3K7a_swiper",
  "viewer": "sj3K7a_viewer",
});
